export default __webpack_public_path__ + "media/actiefgrotesque/ActiefGrotesque_W_Rg-1f437876.woff";